var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('DateRange',{attrs:{"label":_vm.label,"value":_vm.date,"rules":_vm.myrules,"disabled":_vm.disabled},on:{"input":_vm.updateDate}})],1),_c('v-col',[_c('time-picker',{attrs:{"value":_vm.time,"disabled":_vm.disabled || !this.date},on:{"input":_vm.updateTime}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }